var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseView',{staticClass:"mb-5",attrs:{"title":_vm.title},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mb-3"},[_c('b-col',[_c('listado-farmacias')],1)],1)],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }